function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../../ThemeProvider";
var buildStyle = function(param, param1) {
    var spacing = param.spacing, start = param1.start, end = param1.end;
    return {
        base: {
            alignItems: 'center',
            display: 'flex',
            margin: 0
        },
        endIcon: _defineProperty({}, start.margin, spacing[3]),
        startIcon: _defineProperty({}, end.margin, spacing[3])
    };
};
export var useStyle = function(param) {
    var hasChildren = param.hasChildren, isRtl = param.isRtl, reverseSpacing = param.reverseSpacing;
    var style = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    });
    if (typeof style === 'undefined') return {
        iconContainerStyles: {}
    };
    return {
        iconContainerStyles: _objectSpread({}, style.base, hasChildren && reverseSpacing && style.endIcon, hasChildren && !reverseSpacing && style.startIcon)
    };
};
export default useStyle;
